import React, { useState, useRef, useEffect } from "react";
import { Empty, Button, Checkbox, Select, Input } from "antd";
import { useNavigate } from "react-router-dom";

import "./skillMatrixTableSelectable.scss";
import useSkillMatrixStore from "../../store/skillMatrix.store";
import useJDStore from "../../store/jd.store";
import useResumeStore from "../../store/resume.store";

export default function SkillMatrixTableSelectable({
  isClickable = false,
  titleList,
  data,
  isEditField = true,
  candidateSkillMatrixPage = false,
  qhjid,
  resumeID,
  columnWidth,
}) {

  const { handleSkillUpdate, handleRemoveSkill, handleCandidateSkillUpdate } =
    useSkillMatrixStore();

  const { getJdByID } = useJDStore();
  const { setUpdateFlagSpecific } = useResumeStore();
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [clicked, setClicked] = useState(false);
  const ResetCheckBox = () => {
    var checkBoxResetArray = data?.map((idx) => {
      return {
        Skill: idx.skill,
        MentionedExp: idx.mentionedexp,
        SelfRating: idx.selfrating,
        Weightage: idx.weightage,
        isSelected: false,
      };
    });
    setCheckBoxData(() => [...checkBoxResetArray]);
  };
  useEffect(() => {
    const checkBoxArray = data?.map((idx) => {
      return {
        Skill: idx.skill,
        MentionedExp: idx.mentionedexp,
        SelfRating: idx.selfrating,
        Weightage: idx.weightage,
        isSelected: false,
      };
    });
    setCheckBoxData(checkBoxArray);
  }, [data]);

  if (!data) {
    return <Empty style={{ margin: "60px" }} />;
  }

  const onCheckBoxChange = (e) => {
    const index = e.target.value;
    const isChecked = e.target.checked;

    // 1. Create a fresh copy of the array and the specific object being modified
    const updatedData = [...checkBoxData];
    updatedData[index] = {
      ...updatedData[index],
      isSelected: isChecked,
    };

    // 2. Check if any item is selected to enable the update button
    // .some() is more idiomatic than a manual for-loop
    const anySelected = updatedData.some((item) => item.isSelected);

    // 3. Update states
    setUpdateAvailable(anySelected);
    setCheckBoxData(updatedData);
  };



  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };

  const handleRemove = async (value) => {
    const skillsToRemove = checkBoxData
      .filter((item) => item.isSelected)
      .map((item) => item.Skill);
    await handleRemoveSkill(skillsToRemove, qhjid);
    setUpdateAvailable(false);
    getJdByID(qhjid);
    ResetCheckBox();
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValues = [...checkBoxData];
    updatedValues[index] = { ...updatedValues[index], [name]: value };
    setCheckBoxData(updatedValues);
  };

  const handleOnSelectWeightage = (value, index) => {
    console.log("handleOnSelectWeightage", value, index);
    const updatedValues = [...checkBoxData];
    updatedValues[index] = {
      ...updatedValues[index],
      Weightage: value === "1" ? "Mandatory" : "Optional",
    };
    setCheckBoxData(updatedValues);
  };

  const encodeJson = (values) => {
    let skillDetailsArray = [];

    checkBoxData.forEach((item) => {
      if (item.isSelected) {
        skillDetailsArray.push({
          skill: item.Skill,
          mentionedexp: parseFloat(item.MentionedExp),
          selfrating: parseFloat(item.SelfRating),
          weightage: parseInt(item.Weightage === "Mandatory" ? 1 : 0),
        });
      }
    });

    return skillDetailsArray;
  };

  const handleUpdates = async () => {
    var jasonValues = encodeJson();
    if (candidateSkillMatrixPage) {
      await handleCandidateSkillUpdate(jasonValues, qhjid, resumeID);
      setUpdateFlagSpecific()
    } else {
      await handleSkillUpdate(jasonValues, qhjid);
      getJdByID(qhjid);
      setUpdateAvailable(false);      
    }
    ResetCheckBox();
  };

  const weightageList = [
    {
      value: "0",
      label: "Optional",
    },
    {
      value: "1",
      label: "Mandatory",
    },
  ];

  return (
    <div className="skill-matrix-table-selectable-wrapper">
      <div className="skill-matrix-table-selectable-btn-wrapper">
        <Button
          className="skill-matrix-table-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleUpdates}
        >
          Update
        </Button>
        {!candidateSkillMatrixPage && (
          <Button
            className="skill-matrix-table-selectable-btn"
            disabled={!updateAvailable}
            onClick={handleRemove}
          >
            Remove
          </Button>
        )}
      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: columnWidth,
        }}
      >
        {titleList.map((title) =>
          title === "Select" ? (
            <div
              className="rtable-title"
              onClick={() => {
                if (!clicked) {
                  const checkAllBox = checkBoxData.map((item) => ({
                    ...item,
                    isSelected: true,
                  }));
                  setCheckBoxData(checkAllBox);
                  setClicked(true);
                  setUpdateAvailable(true);
                } else {
                  const checkAllBox = checkBoxData.map((item) => ({
                    ...item,
                    isSelected: false,
                  }));
                  setCheckBoxData(checkAllBox);
                  setClicked(false);
                  setUpdateAvailable(false);
                }
              }}
            >
              {title}
            </div>
          ) : (
            <div className="rtable-title">{title}</div>
          ),
        )}
      </div>
      {data?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: columnWidth,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div className="rtable-info">
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}

                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <></>
                    )}

                    {tableInfo === "mentionedexp" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="MentionedExp"
                            value={checkBoxData[rowIndex].MentionedExp}
                            placeholder={checkBoxData[rowIndex].MentionedExp}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "selfrating" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="SelfRating"
                            value={checkBoxData[rowIndex].SelfRating}
                            placeholder={checkBoxData[rowIndex].SelfRating}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "weightage" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            onChange={(event) =>
                              handleOnSelectWeightage(event, rowIndex)
                            }
                            value={
                              checkBoxData[rowIndex].Weightage === "Mandatory"
                                ? "1"
                                : "0"
                            }
                            options={weightageList}
                            // placeholder={checkBoxData[rowIndex].Weightage}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {tableInfo === "date" ? table[tableInfo] : <></>}
                    {tableInfo === "skill" ? table[tableInfo] : <></>}
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
